// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/threat-error-management.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/threat-error-management/threat-error-management.js';

mount([g0]);
